import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=4bafe461&scoped=true&"
import script from "./Employees.vue?vue&type=script&lang=js&"
export * from "./Employees.vue?vue&type=script&lang=js&"
import style0 from "./Employees.vue?vue&type=style&index=0&id=4bafe461&prod&scoped=true&lang=css&"
import style1 from "./Employees.vue?vue&type=style&index=1&id=4bafe461&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafe461",
  null
  
)

export default component.exports